import React from 'react';

import { capitalize } from '@eika-infrastruktur/format';

import useTranslation, { formatJsx } from '../../hooks/useTranslation';
import type { TaskManagerType } from './TaskManagerTypes';

type Props = {
    services: TaskManagerType[];
};

const CombinedServiceNames = ({ services }: Props) => {
    const translated = useTranslation();
    return formatJsx(
        translated.taskManager.multipleErrors.description,
        services
            .map((service) => capitalize(translated.taskManager.errors[service]))
            .reduce(
                (acc, service, index, list) => {
                    if (index > 0 && index === list.length - 1) {
                        return (
                            <>
                                {acc}, {translated.taskManager.multipleErrors.and} <em>{service}</em>
                            </>
                        );
                    }
                    if (index === 0) return <em>{service}</em>;
                    return (
                        <>
                            {acc}, <em>{service}</em>
                        </>
                    );
                },
                <></>,
            ),
    );
};

export default CombinedServiceNames;
